// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/metric.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Value } from "./value_pb.js";

/**
 * Represents a single metric or possibly other metadata about experiment/model
 * bound to an input dataset, e.g., the training or validation dataset.
 *
 * Specific ML backends can also store proprietary scoring information using
 * the json_value or proto_value for the given <experiment,dataset> pair.
 * Information specific to just an experiment is stored in experiment metadata
 * instead.
 *
 * @generated from message ai.h2o.storage.Metric
 */
export const Metric = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.Metric",
  () => [
    { no: 10, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "value", kind: "message", T: Value },
    { no: 13, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

